const Tip = ({
  viewBox = "0 0 24 24",
  size = 24,
  color = "#333",
  ...props
}) => (
  <svg
    viewBox="0 0 1024 1024"
    version="1.1"
    p-id="39920"
    width={size}
    height={size}
    {...props}
  >
    <path
      d="M512 1024C230.4 1024 0 793.6 0 512S230.4 0 512 0s512 230.4 512 512-230.4 512-512 512z m0-938.666667C277.333333 85.333333 85.333333 277.333333 85.333333 512s192 426.666667 426.666667 426.666667 426.666667-192 426.666667-426.666667S746.666667 85.333333 512 85.333333z"
      fill={color}
      p-id="39921"
    ></path>
    <path
      d="M512 631.466667c-25.6 0-42.666667-17.066667-42.666667-42.666667V320c0-25.6 17.066667-42.666667 42.666667-42.666667s42.666667 17.066667 42.666667 42.666667v264.533333c0 25.6-17.066667 46.933333-42.666667 46.933334zM512 789.333333c-12.8 0-21.333333-4.266667-29.866667-12.8-4.266667-4.266667-8.533333-8.533333-8.533333-12.8-4.266667-4.266667-4.266667-12.8-4.266667-17.066666 0-4.266667 0-12.8 4.266667-17.066667 0-4.266667 4.266667-8.533333 8.533333-12.8 17.066667-17.066667 42.666667-17.066667 59.733334 0 4.266667 4.266667 8.533333 8.533333 8.533333 12.8 4.266667 4.266667 4.266667 8.533333 4.266667 17.066667 0 4.266667 0 12.8-4.266667 17.066666 0 4.266667-4.266667 8.533333-8.533333 12.8-8.533333 8.533333-17.066667 12.8-29.866667 12.8z"
      fill={color}
      p-id="39922"
    ></path>
  </svg>
);

export default Tip;
